gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {

    if (!document.querySelector('.overlay')) {
        const overlay = document.createElement('div');
        overlay.className = 'overlay';
        document.body.appendChild(overlay);
    }

    // Helper functions to disable/enable scroll
    const disableScroll = () => {
        document.body.style.overflow = 'hidden';
    };
    const enableScroll = () => {
        document.body.style.overflow = '';
    };

    document.querySelectorAll('.co-home-s3-card--trigger').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const card = this.closest('.co-home-s3-card');
            const more = card.querySelector('.co-home-s3-card--more');
            const excerpt = card.querySelector('.co-home-s3-card--excerpt');
            const overlay = document.querySelector('.overlay'); // make sure this matches your HTML

            card.classList.add('active');
            overlay.classList.add('active');
            disableScroll();

            // Show hidden content instantly (slideDown equivalent)
            if (more) more.style.display = 'block';
            if (excerpt) excerpt.style.display = 'none';
            this.style.display = 'none';

            // Smooth scroll to the active card
            const headerElement = document.getElementById('co_header');
            const headerHeight = headerElement.offsetHeight + 50;

            const rect = card.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetY = rect.top + scrollTop - headerHeight;

            // window.scrollTo({
            //     top: targetY,
            //     behavior: 'smooth'
            // });
            gsap.to(window, {
                duration: .3,            // adjust for speed
                scrollTo: targetY,      // the pixel value to scroll to
                // ease: "power3.inOut"    // buttery-smooth easing
            });
        });
    });

    const overlay = document.querySelector('.overlay');
    // if (overlay) {
    //     overlay.addEventListener('click', function (e) {

    //     });
    // }

    function closeOverlay() {
        // e.preventDefault();

        overlay.classList.remove('active');
        enableScroll();

        document.querySelectorAll('.co-home-s3-card').forEach(card => card.classList.remove('active'));
        document.querySelectorAll('.co-home-s3-card--more').forEach(more => more.style.display = 'none');
        document.querySelectorAll('.co-home-s3-card--trigger').forEach(a => a.style.display = 'inline');
        document.querySelectorAll('.co-home-s3-card--excerpt').forEach(a => a.style.display = 'block');
        // document.querySelectorAll('.about_leadership-cards-card--desc .info-row').forEach(info => info.style.display = 'none');
    }

    // --- Close on overlay click ---
    overlay.addEventListener('click', function (e) {
        e.preventDefault();
        closeOverlay();
    });

    // ---  Close on ESC key ---
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('active')) {
            closeOverlay();
        }
    });

    document.querySelectorAll('.co-home-s3-card').forEach(item => {
        let itemImg = item.querySelector('.co-home-s3-card--media img');
        imageScrollParallax(itemImg, item, "20%", 'bottom', 0, 15);
    });



    //sec 3 end


    // sec 4

    const overlaySec4 = document.querySelector('.co-home-s4');
    function getPrevSection(curr) {
        const parentSection = curr.closest('.shopify-section');
        if (!parentSection) return null;

        const prevSection = parentSection.previousElementSibling;
        return prevSection;
    }

    function getFirstDivInPrevSection(curr) {
        const prevSection = getPrevSection(curr);
        if (!prevSection) return null;

        // get the first <div> inside that previous section
        const firstDiv = prevSection.querySelector('div');
        return firstDiv || null;
    }
    const overlaySec4Pin = getFirstDivInPrevSection(overlaySec4);

    const scrollTriggerHS7 = ScrollTrigger.create({
        trigger: overlaySec4,
        pin: overlaySec4Pin,
        pinSpacing: false,
        start: 'top bottom',
        end: '90% bottom',
        // markers: true,
        invalidateOnRefresh: true
    });

    //Simple Accordion
    var coAccItems = document.querySelectorAll(".co-home-s4-accordion--title");
    var coAccItemsImages = document.querySelectorAll(".co-home-s4-media .media-wrapp");
    // var coAccItemsWrapp = document.querySelectorAll(".co-home-s4-accordion-item");
    // Hide the next sibling element for each item (the content associated with the title)

    console.log(coAccItemsImages);
    coAccItems.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains("active")) {
            groupItem.classList.add("active");
            nextElement.classList.add("active");
            coAccItemsImages[0].classList.add('active');

            gsap.to(nextElement, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
            });
        } else {
            nextElement.classList.remove("active");
            gsap.to(nextElement, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
            });
        }

        groupItem.addEventListener("click", function (e) {
            e.preventDefault();
            // Check if the parent element already has the 'active' class
            if (!this.classList.contains("active")) {
                // If not active, hide all other sections
                coAccItems.forEach(function (otherAccItem, otherIndex) {
                    otherAccItem.classList.remove("active");
                    otherAccItem.nextElementSibling.classList.remove("active");

                    gsap.to(otherAccItem.nextElementSibling, {
                        height: 0,
                        duration: 0.3,
                        ease: "power2.inOut",
                    });
                });
                // Add 'active' class to the clicked item and show its content
                this.classList.add("active");
                nextElement.classList.add("active");
                gsap.to(nextElement, {
                    height: "auto",
                    duration: 0.3,
                    ease: "power2.inOut",
                });

                coAccItemsImages.forEach(function (imageItem) {
                    imageItem.classList.remove('active');
                });
                coAccItemsImages[index].classList.add('active');

            } else {
                // remove 'active' if clicked on 'active'
                this.classList.remove("active");
                nextElement.classList.remove("active");
                gsap.to(nextElement, {
                    height: 0,
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            }

            scrollTriggerHS7.refresh(true);
            // scrollTrigger.refresh(true);
            // scrollTriggerFooter.refresh(true);
            // If already active, don't hide the content
        });


    });

    imageScrollParallax('.co-home-s4-media img', '.co-home-s4', "10%", 'bottom', 0, 10);

    gsap.set('.co-home-s4-illustration', { xPercent: -110 });
    gsap.to('.co-home-s4-illustration', {
        scrollTrigger: {
            trigger: '.co-home-s4',
            // toggleActions: "restart none none",
            // markers: true,
            start: 'top bottom',
            end: "100% bottom",
            scrub: true,
            // markers: true,
            invalidateOnRefresh: true,
        },
        xPercent: 60
    });
    //sec 4

    //sec 5

    //sec 7
    // const chs7Slider = new Swiper('.co-home-s7-swiper', {
    //     speed: 600,
    //     spaceBetween: 10,
    //     loop: true,
    //     slidesPerView: 'auto',
    //     slideToClickedSlide: true,
    //     grabCursor: true,
    //     // initialSlide: 2,
    //     // slidesOffsetAfter:0,
    //     // centeredSlides: true,

    //     // freeMode: true,
    //     // loopAdditionalSlides: 2,

    //     // navigation: {
    //     //     nextEl: itemParent[0].querySelector('.review_section--next'),
    //     //     prevEl: itemParent[0].querySelector('.review_section--prev'),
    //     // },

    //     breakpoints: {
    //         // when window width is >= 320px
    //         320: {
    //             slidesPerView: 1.2,
    //             spaceBetween: 10,
    //         },
    //         // when window width is >= 480px
    //         769: {
    //             slidesPerView: 1.9,
    //             spaceBetween: 10,
    //         },
    //         // when window width is >= 640px
    //         1024: {
    //             slidesPerView: 'auto',
    //             spaceBetween: 10,
    //         }
    //     },
    // });

    var coHS7splide = new Splide('.co-home-s7-swiper', {
        type: 'loop',
        drag: 'free',
        autoWidth: true,
        snap: true,
        speed: 1200,
        // clones: 10,
        focus: 'center',
        updateOnMove: true,
        //   dragMinThreshold: 50,
        // flickPower: 1000,
        //   perPage: 3,
        start: 3,
    });

    coHS7splide.mount();

    // const splideSlides = document.querySelectorAll('.splide__slide');

    // splideSlides.forEach((slide, index) => {
    //     slide.addEventListener('click', () => {
    //         // Get the Splide instance
    //         // const coHS7splide = document.querySelector('.splide').splide;
    //         // Go to the clicked slide
    //         coHS7splide.go(index);
    //     });
    // });
    //sec 7

    //sec 8
    var coHS8splide = new Splide('.co-home-s8-splide', {
        type: 'loop',
        drag: 'free',
        autoWidth: true,
        snap: true,
        speed: 1200,
        // focus: 'center',
        updateOnMove: true,
        // start: 1,
    });

    coHS8splide.mount();
    //sec 8


    // sec 10

    gsap.set('.co-home-s10-accordion-item', { opacity: 0, y: 40 });
    let chs10 = gsap.timeline({ paused: true });
    chs10.to('.co-home-s10-accordion-item', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-home-s10-accordion-item',
        start: "40% bottom",
        end: "bottom top",
        animation: chs10
    });
    //Simple Accordion
    var coAccItemsS10 = document.querySelectorAll(".co-home-s10-accordion--title");
    coAccItemsS10.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains("active")) {
            groupItem.classList.add("active");
            nextElement.classList.add("active");

            gsap.to(nextElement, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
            });
        } else {
            nextElement.classList.remove("active");
            gsap.to(nextElement, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
            });
        }

        groupItem.addEventListener("click", function (e) {
            e.preventDefault();
            // Check if the parent element already has the 'active' class
            if (!this.classList.contains("active")) {
                // If not active, hide all other sections
                coAccItemsS10.forEach(function (otherAccItem, otherIndex) {
                    otherAccItem.classList.remove("active");
                    otherAccItem.nextElementSibling.classList.remove("active");

                    gsap.to(otherAccItem.nextElementSibling, {
                        height: 0,
                        duration: 0.3,
                        ease: "power2.inOut",
                    });
                });
                // Add 'active' class to the clicked item and show its content
                this.classList.add("active");
                nextElement.classList.add("active");
                gsap.to(nextElement, {
                    height: "auto",
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            } else {
                // remove 'active' if clicked on 'active'
                this.classList.remove("active");
                nextElement.classList.remove("active");
                gsap.to(nextElement, {
                    height: 0,
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            }

            ScrollTrigger.refresh(true)
            // If already active, don't hide the content
        });


    });

    coAccItemsS10.forEach(function (item, index) {
        if (index >= 4) {
            item.closest('.co-home-s10-accordion-item').classList.add('hidden');
        }
    });

    coBtnMore = document.querySelector('.co-home-s10-accordion--more');
    coBtnMore.addEventListener('click', function (e) {
        e.preventDefault();
        coAccItemsS10.forEach(function (item, index) {
            item.closest('.co-home-s10-accordion-item').style.animationDelay = '0.1' + index * 10 + 's';
            item.closest('.co-home-s10-accordion-item').classList.remove('hidden');
            item.closest('.co-home-s10-accordion-item').classList.add('visible');
            coBtnMore.style.display = 'none';
        });
        ScrollTrigger.refresh(true)
    });

    //sec 10

    // footerReveal();

});


